enum WorkspaceProjectLandUseAgreementStatus {
  'Draft' = 'Draft',
  'Published' = 'Published',
}

export default WorkspaceProjectLandUseAgreementStatus
